import { ExclusionAreaGeoJSON } from '../../../types/apiModels'
import { EXCLUSION_AREA_TYPE_IDS } from '../../../utils/constants'
import { getFeatureId } from '../utils'

export const validateExclusionArea = (
  area: ExclusionAreaGeoJSON,
  allAreas: ExclusionAreaGeoJSON[],
): Error | null => {
  if (
    area.properties.exclusionAreaTypeId === null ||
    area.properties.exclusionAreaTypeId.toString() === EXCLUSION_AREA_TYPE_IDS.OTHER ||
    area.properties.exclusionAreaTypeId === undefined
  ) {
    return new Error('Debe asignar una categoría válida.')
  }

  if (!area.properties.otherName || area.properties.otherName.trim() === '') {
    return new Error('Debe asignar un nombre.')
  }

  const name = area.properties.otherName.trim()
  const type = area.properties.exclusionAreaTypeId
  const areaId = getFeatureId(area)

  const isDuplicate = allAreas.some(existingArea => {
    if (getFeatureId(existingArea) === areaId) {
      return false
    }

    const existingName = existingArea.properties.otherName?.trim()
    const existingType = existingArea.properties.exclusionAreaTypeId

    return existingName === name && existingType === type
  })

  if (isDuplicate) {
    return new Error(`Ya existe un área con el nombre "${name}" y la misma categoría.`)
  }

  return null
}

export const validateExclusionAreasList = (areas: ExclusionAreaGeoJSON[]): Error | null => {
  const invalidCategory = areas.some(
    area =>
      area.properties.exclusionAreaTypeId === null ||
      area.properties.exclusionAreaTypeId.toString() === EXCLUSION_AREA_TYPE_IDS.OTHER ||
      area.properties.exclusionAreaTypeId === undefined,
  )

  if (invalidCategory) {
    return new Error('Debe asignar una categoría a todas las áreas.')
  }

  const invalidName = areas.some(
    area => !area.properties.otherName || area.properties.otherName.trim() === '',
  )

  if (invalidName) {
    return new Error('Debe asignar un nombre a todas las áreas.')
  }

  const seenCombinations = new Set<string>()
  const duplicates: string[] = []

  areas.forEach(area => {
    const name = area.properties.otherName!.trim()
    const type = area.properties.exclusionAreaTypeId
    const key = `${name}-${type}`

    if (seenCombinations.has(key)) {
      duplicates.push(name)
    } else {
      seenCombinations.add(key)
    }
  })

  if (duplicates.length > 0) {
    return new Error(
      `Existen áreas con nombre y categoría duplicados: ${Array.from(new Set(duplicates)).join(
        ', ',
      )}`,
    )
  }

  return null
}
